// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__ZZsGy","body":"modal_body__jDvgR","close":"modal_close__A1VFS"};